// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1BvIB","colMaxWidth":"Table_colMaxWidth__1lhbt"};